import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', {scope:'/'})
      .then(registration => {
        // console.log('Service Worker registered:', registration);
      })
      .catch(error => {
        // console.log('Service Worker registration failed:', error);
        console.log('Service Worker registration failed');
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

